
import PageHeader from '../../../../Components/UI/PageHeader'
import PayrollsDataTable from '../../../../Components/hr/payrolls/payrollsIndex/payrollsDataTable'

const Payrolls = () => {
 
  return (   
    <div>
      <PageHeader title="Payrolls"  showPayrollsSelect   url={`${process.env.PUBLIC_URL}/payrollsstore`}/>
      <PayrollsDataTable/></div>
  )
}

export default Payrolls